<!--
  [@flipState] deliberately does NOT live on this element (FLIP-121).

  It sits on the .card-side child below. Both CDK drag-drop and the flip
  animation drive `transform`, and CDK's drag preview is a clone of this
  element: with the trigger here the clone arrived carrying the animation's
  `rotateY(...)`, Angular's animation engine re-asserted that state style over
  CDK's `translate3d(...)`, and for one paint the preview rendered at its
  containing block's origin — a card flashing in the top-left corner of the
  screen at the start of every drag. Splitting ownership fixes it: CDK owns the
  transform here, the animation owns the transform on the child.
-->
<div
  class="box"
  cdkDrag
  [cdkDragData]="cardModel"
  [cdkDragDisabled]="isDragDisabled()"
  [id]="'card-' + cardModel?.cardId"
  (cdkDragStarted)="dragEventStarted($event)"
  (cdkDragDropped)="dragEventDropped($event)"
  (cdkDragEnded)="dragEventEnded($event)"
  (cdkDragEntered)="dragEventEntered($event)"
  (cdkDragExited)="dragEventExited($event)"
  [cdkDragStartDelay]="dragStartDelay"
>
  <div class="custom-placeholder" *cdkDragPlaceholder></div>
  <div
    [@flipState]="flip"
    class="d-flex flex-column align-items-center justify-content-start card-container card background unselectable card-side"
    [ngClass]="[backgroundStyle, borderCssClass, cardTypeClass, cardTypeCss]"
    [class.border]="hasBorder"
    [class.selected]="cardSelected"
    [class.complete]="cardModel?.isComplete"
    [class.card-back]="flip === 'active'"
    [class.card-front]="flip === 'inactive'"
    (click)="handleCardAction('clicked'); $event.stopPropagation()"
  >
    <div class="card-complete" *ngIf="cardModel?.isComplete">
      <svg-icon src="assets/plan/icon-star-complete.svg"></svg-icon>
    </div>
    <div class="card-selected" *ngIf="cardSelected"></div>

    <div class="card-controls" *ngIf="controls.showHamburgerMenu">
      <div
        class="legend hamburger-menu {{ cardTypeCss }}"
        (click)="$event.stopPropagation()"
      >
        <app-card-action-menu
          *ngIf="!cardModel?.isComplete"
          (actionClicked)="handleActionMenuClick($event)"
          [card]="cardModel"
          [iconThemeColor]="iconThemeColor"
          [isEditable]="isEditable"
          [isCreate]="isUneditedCustom"
          [showSwap]="controls.showSwap ?? true"
          [canDelete]="canDelete && !canRemove"
          [canRemove]="canRemove"
          [canDuplicate]="canDuplicate"
          [triggerAnchor]="controls.menuTriggerAnchor ?? null"
          [rowAnchorPrefix]="controls.menuRowAnchorPrefix ?? null"
        ></app-card-action-menu>
      </div>
    </div>

    <button
      *ngIf="!!controls.showExpand && !cardModel?.isComplete"
      type="button"
      class="card-expand-icon"
      [flipCoachTarget]="controls.expandAnchor ?? null"
      aria-label="Expand card"
      (click)="handleExpandClick($event)"
    >
      <svg-icon
        src="assets/icons/icon-expand.svg"
        class="parchment"
      ></svg-icon>
    </button>

    <ng-content></ng-content>
  </div>
</div>
